export function main (_p5) {
  let p5
  p5 = _p5
  let parentWidth
  let parentHeight

  let att = []
  let attNum = 1
  let img = []
  let imagePaths = []

  p5.preload = () => {
    imagePaths = ['../static/deJong-images/deJong_1.jpg']
    for (let value of imagePaths) {
      img.push(p5.loadImage(value))
    }
  }
  p5.setup = _ => {
    const parentDiv = document.getElementById('deJong-canvas-wrapper')
    parentWidth = parentDiv.offsetWidth
    parentHeight = parentDiv.offsetHeight
    const canvas = p5.createCanvas(parentWidth, parentHeight)
    canvas.parent('DeJong-canvas')
    // noLoop();
    p5.frameRate(1)
    for (let i = 0; i < img.length; i++) {
      img[i].resize(parentWidth, parentHeight)
    }
    for (let i = 0; i < attNum; i++) {
      att[i] = new Attractor(i)
    }
  }

  p5.windowResized = () => {
    const parentDiv = document.getElementById('deJong-canvas-wrapper')
    parentWidth = parentDiv.offsetWidth
    parentHeight = parentDiv.offsetHeight
    p5.resizeCanvas(parentWidth, parentHeight)
  }

  p5.draw = () => {
    // const fr = p5.frameRate()
    // console.log(fr)
    p5.background(255)
    p5.translate(parentWidth / 2, parentHeight / 2)
    for (let i = 0; i < att.length; i++) {
      att[i].update()
    }
  }

  class Attractor {
    constructor (indexNum) {
      // this.a = 0.7
      // this.b = 1.7
      // this.c = 2.7
      // this.d = -1.4
      this.a = -2
      this.b = -2
      this.c = -1.2
      this.d = 2

      this.x = 1.7
      this.y = 0.0
      this.size = 3
      this.index = indexNum
      this.aStep = 0.04
      this.cStep = 0.02
    }
    update () {
      // this.a += this.aStep
      // this.c += this.cStep
      this.a = p5.map(p5.mouseX, 0, parentWidth, -2, 2)

      if (this.a < -2 || this.a > 2) this.aStep *= -1
      if (this.c < -2 || this.c > 2) this.cStep *= -1

      for (let i = 0; i < 5000; i++) {
        let nx = Math.sin(this.a * this.y) - Math.cos(this.b * this.x)
        let ny = Math.sin(this.c * this.x) - Math.cos(this.d * this.y)
        let posX = (this.x * parentWidth) / 5
        let posY = (this.y * parentHeight) / 5

        let c = img[this.index].get(
          posX + parentWidth / 2,
          posY + parentHeight / 2
        )
        p5.stroke(c)
        p5.point(posX, posY)
        p5.line(
          posX - this.size,
          posY - this.size,
          posX + this.size,
          posY + this.size
        )
        // p5.line(
        //   posX - this.size,
        //   posY + this.size,
        //   posX + this.size,
        //   posY - this.size
        // )

        this.x = nx
        this.y = ny
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/DeJong.js